<template>
  <g>
    <path
      d="M0 0h24v24H0z"
      fill="none"
    /><path d="M14 1h-4a1 1 0 000 2h4a1 1 0 000-2zm-2 13a1 1 0 001-1V9a1 1 0 00-2 0v4a1 1 0 001 1zm7.03-6.61l.75-.75a.993.993 0 000-1.4l-.01-.01a.993.993 0 00-1.4 0l-.75.75A8.962 8.962 0 0012 4a9.1 9.1 0 00-9 8.76 9 9 0 1016.03-5.37zM12 20a7 7 0 117-7 6.995 6.995 0 01-7 7z" />
  </g>
</template>
